import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { AppThunk } from '../actions';
import { MeshDeviceActions } from '../actions/mesh-device-actions';

// const telemetryData: any;

export const MeshDeviceThunks = {
    MeshDeviceRegistration: (
        meshGatewayDeviceData: {
            name: string;
            siteId: string;
            deviceProfileId: string;
            TimeToLive: number;
            dayLightSavingStartDate: string;
            dayLightSavingEndDate: string;
        },
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(MeshDeviceActions.meshGatewayDeviceRegistrationStarted());

        const payload = await ApiRequests.createMeshGatewayDevice(
            {
                name: meshGatewayDeviceData.name,
                siteId: meshGatewayDeviceData.siteId,
                deviceProfileId: meshGatewayDeviceData.deviceProfileId,

                TimeToLive: meshGatewayDeviceData.TimeToLive,
                dayLightSavingStartDate: meshGatewayDeviceData.dayLightSavingStartDate,
                dayLightSavingEndDate: meshGatewayDeviceData.dayLightSavingEndDate,
            },
            { authHelper }
        );
        if (payload.ok) {
            dispatch(
                MeshDeviceActions.meshGatewayDeviceRegistrationSucceeded(
                    payload.response.message,
                    payload.response.data
                )
            );
        } else {
            const errorCode = ApiRequests.extractResponseNotOkCode(payload.response);
            if (errorCode) {
                addToast(ApiRequests.extractResponseNotOkMessage(payload.response), 'error');
            }
            dispatch(MeshDeviceActions.meshGatewayDeviceRegistrationFailed(errorCode.toString()));
        }
    },
};
